import React from "react";

export default function IANComponent(){
    return(
        <h2>Coming Soon...</h2>
    );
}